import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BasicResponse } from '@auth-suite-services/services';
import { Observable, catchError, throwError } from 'rxjs';
import { TemplateInterface } from '../model/template';
import { ConfigService } from './config.service';
import { BankInterface, BankInterfaceAPI } from '../model/bank';

@Injectable({
  providedIn: 'root',
})
export class NoticeboardService {
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(ConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    //changed url call                                                          09/02/24 CN
    // this.URL =
    //   config.REST_SERVER_HOST +
    //   config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'SDSETUP')
    //     .url;
    this.URL = config.REST_SERVER_HOST + '/api/amassapp';

    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getTemplateNoticeBoard(): Observable<TemplateInterface> {
    const headers = this.headers;
    return this.httpClient
      .get<TemplateInterface>(`${this.URL}/tem/gettemplatenoticeboard`, {
        headers,
      })
      .pipe(catchError(this.handleError));
    // const headers = this.headers;
    // return this.httpClient
    //   .get<TemplateInterface>(`${this.URL}/tem/gettemplate/${2}`, { headers })
    //   .pipe(catchError(this.handleError));
  }

  updateTEMNoticeBoard(tem: TemplateInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update tem: ' + JSON.stringify(tem));
    return this.httpClient
      .post<BasicResponse>(
        `${this.URL}/tem/createupdatetemplatenoticeboard`,
        tem,
        {
          headers,
        }
      )
      .pipe(catchError(this.handleError));
  }

  getAllBank(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string
  ): Observable<BankInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient
      .get<BankInterfaceAPI>(
        //`https://amft-dev-gcp.amberfintech.com/api/ammobilebankingrest/util/banks/za`,
        `${this.URL}/nbo/allbank/za/${pageIndex}/${pageSize}/${
          sortActive ? sortActive : 'id'
        }/${sort ? sort : 'asc'}`,
        {
          headers,
        }
      )
      .pipe(catchError(this.handleError));
  }

  updateBankNoticeBoard(id: number, status: number): Observable<BasicResponse> {
    var obj = {
      id: id,
      status: status,
    };
    const headers = this.headers;
    console.log('Update bank status: ' + JSON.stringify(obj));
    return this.httpClient
      .post<BasicResponse>(`${this.URL}/nbo/updatebankstatus`, obj, {
        headers,
      })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }

    return throwError(error);
  }
}
